import {pick, pickBy, mapKeys} from 'lodash'
import {ACTIONS} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import
import type {ActionName} from '@wix/ambassador-devcenter-v1-component-type-data/types'
import type {ManifestFeatureGfppDesktopConfig} from '@wix/document-services-types'
import type {ManifestActionValue} from './types'

export class ActionsHelpers {
    static readonly INITIAL_GFPP_STATE: ManifestFeatureGfppDesktopConfig = {
        mainAction1: {
            behavior: 'DEFAULT'
        },
        iconButtons: {
            add: {
                behavior: 'DEFAULT'
            },
            design: {
                behavior: 'DEFAULT'
            }
        }
    }

    static readonly nativeBuilderActionMap: Map<string, ActionName> = new Map([
        ['settings', ACTIONS.ACTION_NAME.settings],
        ['design', ACTIONS.ACTION_NAME.design],
        ['add', ACTIONS.ACTION_NAME.manageItems]
    ])

    static pickNativeActionValues = (data: ManifestFeatureGfppDesktopConfig): Record<string, ManifestActionValue> => {
        const iconButtons = data?.iconButtons || {}
        return pickBy(iconButtons, (_, key) => ActionsHelpers.nativeBuilderActionMap.has(key))
    }

    static prepareCustomActionValues = (data: ManifestFeatureGfppDesktopConfig) => {
        const mainActions = pick(data, ['mainAction1', 'mainAction2'])
        const supportedIconButtons = new Set(['layout'])

        return {mainActions, supportedIconButtons}
    }

    static getMappedNativeActionKeys = (data: Record<string, ManifestActionValue>) => {
        return mapKeys(data, (_, key) => ActionsHelpers.nativeBuilderActionMap.get(key))
    }

    static isActionHidden = (value?: ManifestActionValue) => {
        return value?.behavior === 'HIDE'
    }
}
